import React from 'react';
import BgSection from './images/section1-bg.png'; // ภาพของคุณที่ใช้เป็น background
import Section2 from './Section2'; // นำเข้า Section2
import Section3 from './Section3'; // นำเข้า Section2

const Section1 = ({ onAddLineClick }) => {
  return (
    <div className="min-h-screen flex flex-col items-center">
      {/* ส่วนที่เป็นรูปภาพหลัก */}
      <div className="relative w-full h-2/4">
        <img 
          src={BgSection} 
          alt="Missy Kim Background" 
          className="w-full h-full object-cover"
        />
      </div>
      <Section2 onAddLineClick={onAddLineClick} />
      <Section3 />
    </div>
  );
}

export default Section1;
